import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.map.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import $ from 'jquery';

//3d文物参数 √
var tex, scale, PLight, Alight, hightlight, photonear, photofar, ambientcolor, pointColor, normalPath, parallelLight, normalMapStrength, manager, group;
var angleX = [];
var angleY = [];
var angleZ = [];
var axisX = [];
var anisY = [];
var anisZ = [];
var tex = [];
var model = [];
var modelName = [];
var mtl = [];
var index2 = [];
var index = [];
var mtlUrl = [];
var mtlName = [];
var normalPath = [];
var stageUrl = process.env.VUE_APP_IMG_URL;
var camera,
  scene,
  renderer,
  controls,
  ob,
  fbx = 0,
  onProgress,
  attributeModels,
  onOtherProgress,
  progressNums = [],
  managerLoading,
  isPercentComplete = false;
export default {
  name: 'pblDetail',
  data() {
    return {
      singleform: {},
      options: {
        source: '',
        width: 480,
        height: 327,
        frames: 34,
        framesX: 6,
        sense: -1
      },
      activeIndex: 0,
      showDetail: true,
      code: '',
      detail: {},
      modelData: {},
      modelCenter: ''
    };
  },
  // props: ['modelData', 'config'],

  methods: {
    hideModel() {
      if (this.detail.type == '3D') {
        this.clearScene();
      }
      this.$parent.hideWindow();
    },
    changeActive(index) {
      this.activeIndex = index;
      this.showDetail = !index ? true : false;
    },
    // 点击音频
    handelAudio() {
      this.$refs.audioItem.paused ? this.$refs.audioItem.play() : this.$refs.audioItem.pause();
    },
    // 文物清空
    clearScene() {
      angleX = [];
      angleY = [];
      angleZ = [];
      axisX = [];
      anisY = [];
      anisZ = [];
      tex = [];
      model = [];
      modelName = [];
      mtl = [];
      index2 = [];
      index = [];
      mtlUrl = [];
      mtlName = [];
      normalPath = [];
      if (scene) {
        scene.traverse(child => {
          if (child.material) {
            child.material.dispose();
          }
          if (child.geometry) {
            child.geometry.dispose();
          }
          child = null;
        });
      }
      if (renderer) {
        renderer.forceContextLoss();
        renderer.dispose();
        renderer.domElement = null;
      }
      controls = null;
      scene = null;
      camera = null;
      renderer = null;
      document.getElementById('Detail_3d').innerHTML = '';
    },
    getDetailByCode() {
      let a = {
        filters: [[{
          alias: "autoId",
          compt: "editinput",
          express: "===",
          id: 28,
          range: null,
          val: this.code
        }]],
        model: 0
      };
      this.singleform.deptId = this.$route.query.fid;
      this.singleform.formId = '112720';
      this.singleform.searchStr = encodeURI(JSON.stringify(a));
      this.$api.singleadvanceSearch(this.singleform).then(res => {
        this.setData(res.dataList[0].formIdValueData, 'name');
      });
    },
    getFileData() {
      let singleformFile = {
        deptId: this.singleform.deptId,
        formId: '113010'
      };
      let b = {
        filters: [[{
          alias: "autoId",
          compt: "editinput",
          express: "===",
          id: 28,
          range: null,
          val: this.code
        }]],
        model: 0
      };
      singleformFile.searchStr = encodeURI(JSON.stringify(b));
      this.$api.singleadvanceSearch(singleformFile).then(res => {
        this.setData(res.dataList[0].formIdValueData);
      });
    },
    // 数据获取
    setData(data, type, hideOther) {
      if (type == 'name') {
        this.detail.name = this.getValInFormData(data, 'antiqueName');
        this.detail.img = this.getValInFormData(data, 'thumbPath', 'img');
        this.detail.description = this.getValInFormData(data, 'description');
        this.detail.audio = this.getValInFormData(data, 'audio', 'objectId');
        this.detail.zhuanti = this.getValInFormData(data, 'mobileSpecial');
        this.detail.code = this.code;
        return this.getFileData();
      } else {
        this.detail.type = this.getValInFormData(data, 'type');
        if (this.detail.audio) {
          this.getAudioPath(this.detail.audio);
        }
        if (this.detail.type == '图片') {
          this.detail.images = data['image'].groupValues[0].values[0].map(img => {
            return process.env.NODE_ENV == 'development' ? stageUrl + img.name : img.fileUrl ? img.fileUrl.replace('http:', 'https:') : '';
          });
          return this.initImage();
        }
        if (this.detail.type == '视频') {
          let objectId = this.getValInFormData(data, 'video', 'objectId');
          return this.getAudioPath(objectId, 'video');
        }
        this.$nextTick(() => {
          console.log(this.detail);
          this.detail.type == '3D' ? this.get3dData(data) : this.init360(data);
        });
      }
    },
    getAudioPath(path, type) {
      this.$api.getUrlByObjectId(path).then(res => {
        let data = res.download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/');
        !type ? this.detail.audio = data : this.detail.video = data;
      });
    },
    // 3d数据解析
    get3dData(data) {
      document.getElementById("bar_" + this.detail.code).innerHTML = '';
      document.getElementById("loadbar_" + this.detail.code).style.display = 'block';
      document.getElementById("bar_" + this.detail.code).style.display = 'block';
      document.getElementById("bar_" + this.detail.code).style.width = '2%';
      let attribute3d = {
        highlight: this.getValInFormData(data, 'highLight'),
        zoomRatio: this.getValInFormData(data, 'zoom'),
        opacity: this.getValInFormData(data, 'transparency'),
        canvasColor: this.getValInFormData(data, 'color'),
        minDistance: this.getValInFormData(data, 'minDistance'),
        maxDistance: this.getValInFormData(data, 'maxDistance'),
        pointLight: this.getValInFormData(data, 'pointLight'),
        pointColor: this.getValInFormData(data, 'pointLightColor'),
        envLight: this.getValInFormData(data, 'environmentLight'),
        envColor: this.getValInFormData(data, 'environmentColor'),
        normalMapStrength: this.getValInFormData(data, 'normalMapStrength'),
        parallelLight: this.getValInFormData(data, 'parallelLight'),
        attributeModels: []
      };
      this.modelCenter = this.getValInFormData(data, 'modelCenter');
      console.log(this.modelCenter, 'this.modelCenter');
      this.detail.attribute3d = attribute3d;
      attributeModels = attribute3d.attributeModels;
      photonear = parseFloat(attribute3d.minDistance); //远相机
      photofar = parseFloat(attribute3d.maxDistance); //近相机
      scale = parseFloat(attribute3d.zoomRatio) * 0.8; //缩放
      PLight = parseFloat(attribute3d.pointLight); //点光
      pointColor = attribute3d.pointColor; //点光颜色
      hightlight = parseFloat(attribute3d.highlight); //半球光颜色、在场景之上，光照颜色从天空光线颜色颜色渐变到地面光线颜色
      Alight = parseFloat(attribute3d.envLight); //环境光
      ambientcolor = attribute3d.envColor; //环境光颜色
      parallelLight = parseFloat(attribute3d.parallelLight); //平行光（太阳光）
      normalMapStrength = parseFloat(attribute3d.normalMapStrength); //法线贴图强度
      if (process.env.NODE_ENV == 'development') {
        data[25].groupValues.map((item, index) => {
          let itemData = {
            angleX: parseFloat(this.getValInFormData(data, 'angleX', '', index)),
            angleY: parseFloat(this.getValInFormData(data, 'angleY', '', index)),
            angleZ: parseFloat(this.getValInFormData(data, 'angleZ', '', index)),
            axisX: parseFloat(this.getValInFormData(data, 'axisX', '', index)),
            axisY: parseFloat(this.getValInFormData(data, 'axisY', '', index)),
            axisZ: parseFloat(this.getValInFormData(data, 'axisZ', '', index)),
            modelName: data[25].groupValues[index].values[0][0] ? data[25].groupValues[index].values[0][0].name : '',
            mtlName: data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].name : '',
            mtlFile: data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].name : '',
            modelPath: data[25].groupValues[index].values[0][0] ? stageUrl + data[25].groupValues[index].values[0][0].name : '',
            normalPath: data[26].groupValues[index].values[0][0] ? stageUrl + data[26].groupValues[index].values[0][0].name : '',
            chartlet: data[24].groupValues[index].values[0][0] ? stageUrl + data[24].groupValues[index].values[0][0].name : ''
          };
          attributeModels.push(itemData);
          if (attributeModels.length == data[25].groupValues.length) {
            setTimeout(() => {
              this.init3d();
              this.animate();
            }, 1000);
          }
        });
      } else {
        let t_url = {};
        data[25].groupValues.map((item, index) => {
          let t_name = [];
          let itemData = {
            angleX: parseFloat(this.getValInFormData(data, 'angleX', '', index)),
            angleY: parseFloat(this.getValInFormData(data, 'angleY', '', index)),
            angleZ: parseFloat(this.getValInFormData(data, 'angleZ', '', index)),
            axisX: parseFloat(this.getValInFormData(data, 'axisX', '', index)),
            axisY: parseFloat(this.getValInFormData(data, 'axisY', '', index)),
            axisZ: parseFloat(this.getValInFormData(data, 'axisZ', '', index)),
            modelName: data[25].groupValues[index].values[0][0] ? data[25].groupValues[index].values[0][0].name : '',
            mtlName: data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].name : '',
            normalPath: data[26].groupValues[index].values[0][0] ? `https://museum.chaoxing.com/star3/origin/${data[26].groupValues[index].values[0][0].objectId}.${data[26].groupValues[index].values[0][0].suffix}` : ''
          };
          let model1 = this.$api.getUrlByObjectId(data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].objectId : '');
          let model2 = this.$api.getUrlByObjectId(data[25].groupValues[index].values[0][0] ? data[25].groupValues[index].values[0][0].objectId : '');
          // let model3 = this.$api.getUrlByObjectId(data[24].groupValues[index].values[0][0] ? data[24].groupValues[index].values[0][0].objectId : '')
          let ts = data[24].groupValues[index].values[0];
          let modelAll = [model1, model2];
          ts.map(t => {
            let m = this.$api.getUrlByObjectId(t.objectId);
            modelAll.push(m);
            t_name.push(t.name);
            let t_name_str = t.name.toLocaleLowerCase();
            t_url[t_name_str] = `https://museum.chaoxing.com/star3/origin/${t.objectId}.${t.suffix}`;
          });
          itemData.chartlet = data[24].groupValues[index].values[0][0] ? `https://museum.chaoxing.com/star3/origin/${data[24].groupValues[index].values[0][0].objectId}.${data[24].groupValues[index].values[0][0].suffix}` : '';
          Promise.all(modelAll).then(res => {
            // mtl文件
            itemData.mtlFile = res[0].download || '';
            itemData.mtlFile = itemData.mtlFile.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/').replace('http://d0.cldisk.com/', 'https://museum.chaoxing.com/cldisk/');
            // 模型文件
            itemData.modelPath = res[1].download || '';
            itemData.modelPath = itemData.modelPath.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/').replace('http://d0.cldisk.com/', 'https://museum.chaoxing.com/cldisk/');
            // 贴图
            res.map((r, t_index) => {
              if (t_index > 1) {
                let t_name_str = t_name[t_index - 2].toLocaleLowerCase();
                // t_url[t_name_str] = r.download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/')
                console.log(t_name_str, 111);
              }
            });
            if (t_name.length > 0) {
              window.localStorage.setItem("t_url", JSON.stringify(t_url));
            }
            attributeModels.push(itemData);
            if (attributeModels.length == data[25].groupValues.length) {
              console.log(attributeModels);
              setTimeout(() => {
                this.init3d();
                this.animate();
              }, 1000);
            }
          });
        });
      }
    },
    getValInFormData(data, id, type, index) {
      index = index ? index : 0;
      if (!data[id] || !data[id].groupValues[index] || !data[id].groupValues[index].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[index].values[0][0]) return;
        target = process.env.NODE_ENV == 'development' ? stageUrl + data[id].groupValues[index].values[0][0].name : data[id].groupValues[index].values[0][0].fileUrl;
        target = target && process.env.NODE_ENV != 'development' ? target.replace('http:', 'https:') : target;
      } else {
        target = type ? data[id].groupValues[index].values[0][0][type] : data[id].groupValues[index].values[0][0].val;
      }
      return target;
    },
    // 3d文物加载
    init3d() {
      attributeModels.map((a, i) => {
        angleX.push(a.angleX); //x轴
        angleY.push(a.angleY); //y轴
        angleZ.push(a.angleZ); //z轴
        axisX.push(a.axisX); //x轴
        anisY.push(a.axisY); //y轴
        anisZ.push(a.axisZ); //z轴
        model.push(a.modelPath); //文物路径
        // index2.push(model[i].lastIndexOf("\/"));
        // console.log(index2)
        modelName.push(a.modelName); //文物名称
        if (a.chartlet) {
          var new_c = a.chartlet.split('|');
          for (var c = 0; c < new_c.length; c++) {
            tex.push(new_c[c]);
          }
          //文物贴图
        }
        if (a.normalPath) {
          var new_n = a.normalPath.split('|');
          for (var c = 0; c < new_n.length; c++) {
            normalPath.push(new_n[c]);
          }
          //文物贴图
        }
        if (a.mtlFile) {
          mtl.push(a.mtlFile); //文物mtl
          index.push(mtl[i].lastIndexOf("\/"));
          // mtlUrl.push(mtl[i].substring(0, index[i] + 1));
          var urlMtl = process.env.NODE_ENV == 'development' ? stageUrl : a.mtlFile.indexOf('cldisk') > -1 ? 'https://museum.chaoxing.com/cldisk/download/' : 'https://museum.chaoxing.com/download/';
          mtlUrl.push(urlMtl);
        }
        if (a.mtlName) {
          mtlName.push(a.mtlName);
        }
      });
      console.log(attributeModels, '322');
      let that = this;
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(35, this.$refs.contain.offsetWidth / this.$refs.contain.offsetHeight, photonear, photofar);
      camera.position.z = 250;
      scene.add(camera);
      group = new THREE.Object3D();
      if (parallelLight) {
        let directionalLight = new THREE.DirectionalLight(0xffffff, parallelLight);
        directionalLight.position.set(0, 0, 250);
        scene.add(directionalLight);
      }
      // 半球光，在场景之上从上到下的光
      var ambientLight = new THREE.AmbientLight(0xffffff, Alight);
      scene.add(ambientLight);
      var hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff, hightlight);
      hemiLight.position.set(0, 500, 0);
      scene.add(hemiLight);
      // 四个点光源
      var pointLight = new THREE.PointLight(0xffffff, PLight);
      pointLight.position.set(-300, 0, -100);
      scene.add(pointLight);
      var pointLight1 = new THREE.PointLight(0xffffff, PLight);
      pointLight1.position.set(100, 0, 300);
      scene.add(pointLight1);
      var pointLight2 = new THREE.PointLight(0xffffff, PLight);
      pointLight2.position.set(300, 0, -300);
      scene.add(pointLight2);
      var pointLight4 = new THREE.PointLight(0xffffff, PLight);
      pointLight4.position.set(0, -300, 0);
      scene.add(pointLight4);
      manager = new THREE.LoadingManager();
      var code = this.code;
      manager.onLoad = function () {
        console.log('onLoadManager');
        managerLoading = true;
        if (!isPercentComplete) return;
        // 所有资源都加载完成后执行事件
        setTimeout(function () {
          document.getElementById("loadbar_" + code).style.display = 'none';
          document.getElementById("bar_" + code).style.display = 'none';
        }, 500);
      };
      //加载进度
      onProgress = function (xhr) {
        if (xhr.lengthComputable) {
          var percentComplete = xhr.loaded / xhr.total * 100;
          var percent = document.getElementById("bar_" + code);
          if (!percent) return;
          if (percentComplete == 100) {
            progressNums.push(100);
          }
          if (percentComplete > 80 && attributeModels.length != 1 && progressNums.length != attributeModels.length) {} else {
            var speed = Math.round(percentComplete, 2);
            percent.innerText = Math.round(percentComplete, 2) + '% 已经加载';
            document.getElementById("bar_" + code).style.width = speed == 0 ? 0 : speed - 1 + "%";
            document.getElementById("bar_" + code).innerHTML = speed == 0 ? 0 : speed - 1 + "%";
            if (percentComplete == 100) {
              isPercentComplete = true;
              if (!managerLoading) return;
              setTimeout(function () {
                document.getElementById("loadbar_" + code).style.display = 'none';
                document.getElementById("bar_" + code).style.display = 'none';
              }, 1500);
            }
          }
        }
      };
      // 多个模型进度条加载
      onOtherProgress = function (xhr) {
        var percentComplete = xhr.loaded / xhr.total * 100;
        if (percentComplete == 100) {
          progressNums.push(100);
        }
        if (progressNums.length == attributeModels.length && percentComplete > 80) {
          var percent = document.getElementById("bar_" + code);
          if (!percent) return;
          var speed = Math.round(percentComplete, 2);
          percent.innerText = Math.round(percentComplete, 2) + '% 已经加载';
          document.getElementById("bar_" + code).style.width = speed - 1 + "%";
          document.getElementById("bar_" + code).innerHTML = speed - 1 + "%";
          if (percentComplete == 100) {
            isPercentComplete = true;
            if (!managerLoading) return;
            setTimeout(function () {
              document.getElementById("loadbar_" + code).style.display = 'none';
              document.getElementById("bar_" + code).style.display = 'none';
            }, 1500);
          }
        }
      };
      // scale = 0.5
      console.log(mtlName, 'mtlName');
      if (modelName[0].match('.obj') || modelName[0].match('.OBJ')) {
        // 暂时只加载1个mtl
        if (mtlName[0] && mtlName[0].match('.mtl')) {
          that.loadNextMtl(0);
        } else {
          that.loadNextObj(0);
        }
      } else {
        fbx = 1;
        //可以在这里更换fbx试试其他效果
        loader.load(model[0], function (object) {
          object.position.set(0, 0, 0);
          object.scale.set(scale, scale, scale);
          ob = object;
          scene.add(object);
          object.children[0].geometry.center();
        });
      }
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      });
      renderer.setClearAlpha(0.0);
      renderer.setPixelRatio(window.devicePixelRatio);
      let h = this.$refs.contain.offsetHeight;
      let w = this.$refs.contain.offsetWidth;
      renderer.setSize(w, h);
      document.getElementById('Detail_3d').appendChild(renderer.domElement);
      controls = new THREE.TrackballControls(camera, renderer.domElement);
      controls.minDistance = 200;
      controls.maxDistance = 2000;
    },
    loadNextMtl(i) {
      let that = this;
      if (i > modelName.length - 1) return;
      var loader = new THREE.TextureLoader(manager);
      loader.setCrossOrigin("Anonymous");
      var mtlLoader = new THREE.MTLLoader(manager);
      mtlLoader.setCrossOrigin("Anonymous");
      mtlLoader.setPath(mtlUrl[i]); // obj mtl文件的目录
      let mtlLoaderName = mtl[i].replace(mtlUrl[i], '');
      mtlLoader.load(mtlLoaderName, function (materials) {
        materials.preload();
        var objLoader = new THREE.OBJLoader();
        objLoader.setMaterials(materials);
        objLoader.load(model[i], function (object) {
          object.children[0].geometry.computeBoundingBox();
          console.log(that.modelCenter, 2222);
          if (that.modelCenter == '开启') {
            object.children[0].geometry.center();
          }
          object.scale.x = object.scale.y = object.scale.z = scale;
          object.rotation.set(Math.PI * Number(angleX[i] / 180), Math.PI * Number(angleY[i] / 180), Math.PI * Number(angleZ[i] / 180));
          object.position.set(axisX[i], anisY[i], anisZ[i]);
          group.add(object);
          that.render();
        }, i == 0 ? onProgress : onOtherProgress);
        scene.add(group);
        that.loadNextMtl(i + 1);
      });
    },
    loadNextObj(i) {
      let that = this;
      let a = i;
      if (i > modelName.length - 1) return;
      var textureLoader = new THREE.TextureLoader();
      var texture = textureLoader.load(tex[i]);
      texture.minFilter = THREE.NearestFilter;
      var textureNormal;
      if (normalPath.length) {
        var normalImg = normalPath[i];
        textureNormal = textureLoader.load(normalImg);
      }
      var loader = new THREE.OBJLoader(manager);
      loader.load(model[i], function (object) {
        object.traverse(function (child) {
          if (child instanceof THREE.Mesh) {
            child.material = new THREE.MeshPhongMaterial({
              map: texture,
              normalMap: textureNormal,
              normalScale: new THREE.Vector2(normalMapStrength, normalMapStrength),
              emissive: texture,
              shininess: 1000,
              needsUpdate: true
            });
          }
        });
        object.children[0].geometry.computeBoundingBox();
        // object.children[0].geometry.center();
        if (that.modelCenter == '开启') {
          object.children[0].geometry.center();
        }
        object.scale.x = object.scale.y = object.scale.z = scale;
        object.rotation.set(Math.PI * Number(angleX[a] / 180), Math.PI * Number(angleY[a] / 180), Math.PI * Number(angleZ[a] / 180));
        object.position.set(axisX[a], anisY[a], anisZ[a]);
        // group.add(object);
        // scene.add(group);
        group.add(object);
        that.render();
      }, i == 0 ? onProgress : onOtherProgress);
      scene.add(group);
      that.loadNextObj(i + 1);
    },
    animate() {
      requestAnimationFrame(this.animate);
      if (controls) {
        controls.update();
        this.render();
      } else {
        cancelAnimationFrame(this.animate);
      }
    },
    render() {
      renderer.render(scene, camera);
    }
  },
  mounted() {
    this.code = this.$route.query.code;
    this.getDetailByCode();
  },
  created() {
    this.boxTop = window.screen.height > 3850 ? 1920 : 900;
    let list1 = ['FBXLoader.js', 'inflate.min.js', 'TGALoader.js', 'TrackballControls.js', 'PDBLoader.js', 'CSS2DRenderer.js', 'OBJLoader.js', 'FBXLoader.js', 'MTLLoader.js', 'Detector.js'];
    list1.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/3d/${item}`;
      document.body.appendChild(oScript);
    });
  },
  computed: {},
  watch: {
    '$route'(to, from) {
      location.reload();
    }
  }
};